import { Component, ChangeDetectionStrategy, EventEmitter, Input, Output } from '@angular/core';
import { IUserBonus } from 'src/app/shared/types/users.types';

@Component({
  selector: 'app-user-bonus',
  templateUrl: './user-bonus.component.html',
  styleUrls: ['./user-bonus.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class UserBonusComponent {
  @Input()
  public userBonus: IUserBonus;

  @Input()
  public canManageBonuses: boolean | null;

  @Input()
  public whitelabelTemplate?: boolean;

  @Output()
  public delete: EventEmitter<IUserBonus> = new EventEmitter();

  public onDeleteClick(): void {
    this.delete.emit(this.userBonus);
  }
}
